import React, { useEffect, useState } from 'react';
import Input from './Input';
import { useTranslation } from 'react-i18next';
import RadioButtonGroup from './RadioButtonGroup';
import Select from './Select';
import DatePicker from './DatePicker';
import { useSession } from '../context/SessionContext';
import Button from './Button';
import MyText from './MyText';
import toast from 'react-hot-toast';
import { useApi } from '../context/ApiContext';
import { useLocation } from 'react-router-dom';
import LocalitaSelect from './LocalitaSelect';

export default function StepAnagrafica({ nextCallback }) {
    const { session, saveSession } = useSession();
    const { getAllProfileInfo, getFieldValues,
        fieldsCV, setFieldsAltri, setFieldsCV, setFieldsLet } = useApi();
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const [width, setWidth] = useState(window.innerWidth);
    const [state, setState] = useState({
        nome: session.nome ? session.nome : '',
        cognome: session.cognome ? session.cognome : '',
        sesso: session.sesso ? session.sesso : '',
        dataDiNascita: session.dataDiNascita ? session.dataDiNascita : '',
        nazionalita: session.nazionalita ? session.nazionalita : '',
        paese: session.paese ? session.paese : '',
        indirizzo: session.indirizzo ? session.indirizzo : '',
        localita: session.localita ? session.localita : '',
        provincia: session.cantoneProvincia ? session.cantoneProvincia : '',
        npa: session.npa ? session.npa : '',
        nazione: session.nazione ? session.nazione : '',
        statutoDiSoggiorno: session.statutoDiSoggiorno ? session.statutoDiSoggiorno : '',
        telefono: session.telefono ? session.telefono : '',
        mail: session.mail ? session.mail : '',
        siglaNazione: session.siglaNazione ? session.siglaNazione : ''
    });
    const [countryOptions, setCountryOptions] = useState([]);
    const [sessoOptions, setSessoOptions] = useState([]);
    const [nazionalitaOptions, setNazionalitaOptions] = useState([]);
    const [statutoOptions, setStatutoOptions] = useState([]);
    const [localitaOptions, setLocalitaOptions] = useState([]);
    const [localitaOptionsIT, setLocalitaOptionsIT] = useState([]);
    const [localitaOptionsCH, setLocalitaOptionsCH] = useState([]);
    const simpleOptions = [
        { code: "CH", name: "Svizzera" },
        { code: "IT", name: "Italia" },
        { code: "Altro paese", name: "Altro paese" },
    ]

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [setWidth])

    useEffect(() => {
        getAllProfileInfo().then((res) => {
            setFieldsCV(res[0]);
            setFieldsLet(res[1]);
            setFieldsAltri(res[2]);
        });
    }, [pathname])

    useEffect(() => {
        const populateSelect = async () => {
            if (fieldsCV.length === 0) return;

            const aField = fieldsCV
                .filter(item => item.externalId === "NPA-Localita" || item.externalId === "NazioneFornitore" || item.externalId === "StatutoDiSoggiorno" || item.externalId === "Nazionalita" || item.externalId === "Sesso");
            const nat = aField.find(x => x.externalId === 'NazioneFornitore');
            const sesso = aField.find(x => x.externalId === 'Sesso');
            const stat = aField.find(x => x.externalId === 'StatutoDiSoggiorno');
            const loc = aField.find(x => x.externalId === 'NPA-Localita');
            const naz = aField.find(x => x.externalId === 'Nazionalita');
            const natRes = nat ? await getFieldValues(nat.name, false) : [];
            const sessoRes = sesso ? await getFieldValues(sesso.name) : [];
            const statRes = stat ? await getFieldValues(stat.name, false) : [];
            const locRes = loc ? await getFieldValues(loc.name, false) : [];
            const nazRes = naz ? await getFieldValues(naz.name) : [];

            const natOptions = natRes.reduce((acc, item) => {
                acc.push({
                    code: item[0],
                    name: item[0],
                    sigla: item[4]
                });
                return acc;
            }, []);

            const sesOptions = sessoRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            const statOptions = statRes.reduce((acc, item, index) => {
                acc.push({
                    code: item[1],
                    name: item[1],
                })
                return acc
            }, []);

            const locOptions = locRes.reduce((acc, item) => {
                if (item[4] !== "IT" && item[4] !== "CH") return acc;
                acc[item[4]].push({
                    code: item[0],
                    name: item[0],
                    provincia: item[3],
                    paese: item[4]
                });
                return acc;
            }, {"IT": [], "CH": []});

            const nazOptions = nazRes.reduce((acc, item) => {
                acc.push({
                    code: item,
                    name: item,
                })
                return acc
            }, []);

            setSessoOptions(sesOptions);
            setStatutoOptions(statOptions)
            setCountryOptions(natOptions);
            setNazionalitaOptions(nazOptions);
            setLocalitaOptions([...locOptions["IT"], ...locOptions["CH"]]);
            setLocalitaOptionsIT(locOptions["IT"]);
            setLocalitaOptionsCH(locOptions["CH"]);
        }
        populateSelect()
    }, [fieldsCV])


    useEffect(() => {
        if (state.paese === "IT"){
            setState({...state, localita: '', provincia: '', nazione: "Italia", siglaNazione: "IT"})
        } else if (state.paese === "CH") {
            setState({...state, localita: '', provincia: '', nazione: "Svizzera", siglaNazione: "CH"})
        } else {
            setState({...state, localita: '', provincia: '', nazione: ''})
        }
    }, [state.paese]);

    useEffect(() => {
        const updateProvincia = () => {
            const oLoc = localitaOptions.find(x => x.code === state.localita);
            if (oLoc && oLoc.provincia){
                setState({...state, provincia: oLoc.provincia})
            }
        };
        updateProvincia();
    }, [state.localita]);

    useEffect(() => {
        const updateSigla = () => {
            const oNat = countryOptions.find(x => x.code === state.nazione);
            if (oNat && oNat.sigla){
                setState({...state, sigla: oNat.sigla})
            }
        };
        updateSigla();
    }, [state.nazione])

    const handleChange = (e, property) => {
        setState({
            ...state,
            [property]: e.target.value,
        });
    }
    const handleRadioChange = (x, property) => {
        // console.log("stato", state);
        setState({
            ...state,
            [property]: x,
        });
    }

    const isAnagraficaComplete = () => {
        const bRequired = state.nome && state.cognome && state.sesso && state.dataDiNascita && state.paese && state.localita && state.indirizzo && state.telefono && state.mail && state.nazionalita && state.nazione;
        const bItaRequired = state.paese === 'IT' ? state.provincia : true;
        const bSwissRequired = state.paese === 'CH' ? localitaOptionsCH.find(x => x.code === state.localita) && state.provincia : true;
        const bAltroRequired = state.paese === "Altro paese" ? state.npa : true
        const bStatutoRequired = state.nazionalita === "svizzera" || state.statutoDiSoggiorno
        return bRequired && bItaRequired && bSwissRequired && bAltroRequired && bStatutoRequired;
    }

    const checkRegex = () => {
        const [mailString, mobileString] = fieldsCV
        .filter(item => item.externalId === "Mobile" || item.externalId === "Mail")
        .map(item => item.validationString);
        const mailRegex = new RegExp(mailString);
        const mobileRegex = new RegExp(mobileString);
        if (!mailRegex.test(state.mail)){
            toast.error(t('form_emailError'))
            return false
        } if (!mobileRegex.test(state.telefono)){
            toast.error(t('form_telefonoError'))
            return false
        }
        return true
    }

    const handleSalva = () => {
        var ITLocValid = state.paese === "IT" && localitaOptionsIT.find(x => x.code === state.localita);
        var CHLocValid = state.paese === "CH" && localitaOptionsCH.find(x => x.code === state.localita);
        if (["IT","CH"].includes(state.paese) && !ITLocValid && !CHLocValid){
            toast.error(t('form_localitaError'));
            return;
        }
        var mmValid = checkRegex();
        if (!mmValid){
            return;
        }
        var bValid = isAnagraficaComplete();
        if (!bValid) {
            toast.error(t('form_error'));
            return;
        }
        saveSession({
            ...state,
            "NPA": ["IT","CH"].includes(state.paese) ? state.localita.split("-")[0].trim() : state.npa,
            "NPA-Localita": ["IT","CH"].includes(state.paese) ? state.localita :
            `${state.npa} - ${state.localita}`,
            "Localita": ["IT","CH"].includes(state.paese) ? state.localita.split("-")[1].trim() : state.localita,
            "cantoneProvincia": state.provincia,
            "mobile": state.telefono,
            "paeseResidenza": ["IT", "CH"].includes(state.paese)
                ? state.paese === "IT" ? "Italia" : "Svizzera"
                : "Altro paese",
            "nazioneFornitore": state.nazione
        })
        nextCallback && nextCallback();
    };

    return (
        <div style={styles.container}>
            <Input label={t('step1_nomeLabel')} value={state.nome} onChange={(e) => handleChange(e, "nome")} />
            <Input label={t('step1_cognomeLabel')} value={state.cognome} onChange={(e) => handleChange(e, "cognome")} />
            <Select label={t('step1_sessoLabel')} value={state.sesso} onChange={(e) => handleChange(e, "sesso")} data={sessoOptions} />
            <DatePicker label={t('step1_dataNascitaLabel')} value={state.dataDiNascita} onChange={(e) => handleChange(e, "dataDiNascita")} />
            <LocalitaSelect idList={"nazionalita"} label={t('step1_nazionalitaLabel')} value={state.nazionalita} onChange={(e) => handleChange(e, "nazionalita")} data={nazionalitaOptions} />

            {/* Paese di residenza che non serve, ha tre opzioni */}
            <Select label={t('step1_paeseLabel')} value={state.paese} onChange={(e) => handleChange(e, "paese")} data={simpleOptions} />

            {/* Indirizzo */}
            {state.paese !== '' && <Input label={t('step1_indirizzoLabel')} value={state.indirizzo} onChange={(e) => handleChange(e, "indirizzo")} />}

            {/* NPA - Localita e PROVINCIA per IT o CH */}
            {state.paese === 'CH' &&
                <div style={{ ...styles.indirizzoContainer, flexDirection: width > 900 ? 'row' : 'column' }}>
                    {/* <Select containerStyle={{ flex: 0.7 }} label={t('step1_localitaLabel')} value={state.localita} onChange={(e) => handleChange(e, "localita")} data={localitaOptionsCH} /> */}
                    <LocalitaSelect idList={"localitaCH"} containerStyle={{ flex: 0.7 }} label={t('step1_localitaLabel')} value={state.localita} onChange={(e) => handleChange(e, "localita")} data={localitaOptionsCH} />
                    <Input readOnly={true} containerStyle={{ flex: 0.3 }} label={t('step1_provinciaLabel')} value={state.provincia} />
                </div>}
            {state.paese === 'IT' &&
                <div style={{ ...styles.indirizzoContainer, flexDirection: width > 900 ? 'row' : 'column' }}>
                    {/* <Select containerStyle={{ flex: 0.7 }} label={t('step1_localitaLabel')} value={state.localita} onChange={(e) => handleChange(e, "localita")} data={localitaOptionsIT} /> */}
                    <LocalitaSelect idList={"localitaIT"} containerStyle={{ flex: 0.7 }} label={t('step1_localitaLabel')} value={state.localita} onChange={(e) => handleChange(e, "localita")} data={localitaOptionsIT} />
                    <Input readOnly={true} containerStyle={{ flex: 0.3 }} label={t('step1_provinciaLabel')} value={state.provincia} />
                </div>}

            {/* Localita per altro paese */}
            {state.paese === 'Altro paese' && <Input label={t('step1_localitaLabel')} value={state.localita} onChange={(e) => handleChange(e, "localita")} />}

            {/* NPA per altro paese */}
            {state.paese === 'Altro paese' && <Input label={t('step1_npaLabel')} value={state.npa} onChange={(e) => handleChange(e, "npa")} />}

            {/* Nazione che serve, ha tutte le opzioni */}
            {state.paese !== '' && <LocalitaSelect idList={"nazione"} label={t('step1_nazioneLabel')} value={state.nazione} onChange={(e) => handleChange(e, "nazione")} data={countryOptions} />}

            {state.nazionalita !== "svizzera" && <Select label={t('step1_statutoLabel')} value={state.statutoDiSoggiorno} onChange={(e) => handleChange(e, "statutoDiSoggiorno")} data={statutoOptions} />}
            <Input label={t('step1_telefonoLabel')} value={state.telefono} onChange={(e) => handleChange(e, "telefono")} />
            <Input label={t('step1_emailLabel')} value={state.mail} onChange={(e) => handleChange(e, "mail")} />
            <div style={{ height: 0 }} />
            <div style={styles.buttonContainer}>
                <Button onClick={handleSalva}>
                    <MyText>{t('form_salvaProsegui')}</MyText>
                </Button>
            </div>
        </div>
    );
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 40,
    },
    indirizzoContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 20,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 40
    }
}